<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="8">
                <h1 class="headline font-weight-light mb-3">
                    CTR Part
                </h1>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
                <v-text-field
                    v-model="form_search"
                    label="Search Part / Enter"
                    outlined
                    dense
                    v-on:keyup.enter="get_data()"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mar-t-10">
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        Qty. Part @ Branch
                    </v-card-title>

                    <v-expand-transition>
                        <div>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        Branch
                                                    </th>
                                                    <th class="text-center">
                                                        RF No.
                                                    </th>
                                                    <th class="text-center">
                                                        Onhand
                                                    </th>
                                                    <th class="text-center">
                                                        Reserve
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="data_main.length == 0">
                                                <tr>
                                                    <td
                                                        class="text-center"
                                                        colspan="5"
                                                    >
                                                        <span
                                                            v-if="
                                                                chk_search ==
                                                                    false
                                                            "
                                                            >No results</span
                                                        >
                                                        <v-progress-linear
                                                            v-if="
                                                                chk_search ==
                                                                    true
                                                            "
                                                            indeterminate
                                                            color="cyan"
                                                        ></v-progress-linear>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody
                                                v-for="(row,
                                                index) in data_main"
                                                :key="index"
                                            >
                                                <tr class="bg-tr-1">
                                                    <td colspan="5">
                                                        <span class="font-b">{{
                                                            row.zone
                                                        }}</span>
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(r,
                                                    i) in row.branchs"
                                                    :key="i"
                                                >
                                                    <td class="text-center">
                                                        {{ i + 1 }}.
                                                    </td>
                                                    <td>
                                                        <v-btn
                                                            :disabled="
                                                                row.onhand == 0
                                                            "
                                                            rounded
                                                            small
                                                            class="primary--text"
                                                            @click="
                                                                dialog_open(r)
                                                            "
                                                            >{{
                                                                r.branch_name
                                                            }}</v-btn
                                                        >
                                                    </td>
                                                    <td class="text-center">
                                                        {{ r.rf_no }}
                                                    </td>
                                                    <td class="text-right">
                                                        <span
                                                            class="success--text font-b"
                                                            >{{
                                                                r.onhand
                                                            }}</span
                                                        >
                                                    </td>
                                                    <td class="text-right">
                                                        <span
                                                            class="primary--text font-b"
                                                            >{{
                                                                r.reserve
                                                            }}</span
                                                        >
                                                    </td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-form method="post" id="nativeForm" v-model="valid">
                <v-dialog v-model="dialog" persistent max-width="550px">
                    <v-card>
                        <v-card-title>
                            Reserve Part
                        </v-card-title>
                        <v-card-subtitle
                            ><span class="primary--text">
                                {{
                                    show.part_name +
                                        " / " +
                                        show.part_description +
                                        " / " +
                                        show.rf_no +
                                        " / " +
                                        show.branch_name
                                }}
                            </span></v-card-subtitle
                        >
                        <v-card-subtitle
                            ><span class="primary--text"> </span
                        ></v-card-subtitle>
                        <v-card-text>
                            <v-container>
                                <v-row class="mar-t-40">
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="form.case_id"
                                            label="Case No"
                                            required
                                            outlined
                                            dense
                                            :rules="case_idR"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="mar-t-30">
                                        <v-text-field
                                            v-model="form.ponumber"
                                            label="PO Number"
                                            required
                                            outlined
                                            dense
                                            :rules="ponumberR"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="mar-t-30">
                                        <v-text-field
                                            v-model="form.sonumber"
                                            label="SO Number"
                                            required
                                            outlined
                                            dense
                                            :rules="sonumberR"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" class="mar-t-30">
                                        <v-text-field
                                            v-model="form.qty"
                                            label="Qty"
                                            required
                                            outlined
                                            dense
                                            :rules="qtyR"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="mar-t-40">
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="dialog_close()"
                            >
                                Close
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                @click="save_ctr_part()"
                                :disabled="!valid"
                            >
                                <v-icon right dark>mdi-content-save</v-icon>
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    computed: {
        ...mapState(["snackbar"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        //
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            if (this.form_search != "") {
                this.data_main = []
                let send = {
                    search: this.form_search,
                }
                this.chk_search = true
                await axios
                    .post(url + "ctr-part/search", send, this.tk)
                    .then((response) => {
                        console.log(response)
                        this.chk_search = false
                        if (response.data.status == "error") {
                            this.$swal({
                                title: "Alert",
                                text: response.data.data,
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        } else {
                            this.form.part_id = response.data.part_id
                            this.data_main = response.data.data
                        }
                    })
            }
        },
        dialog_open(data) {
            this.show = data
            this.form.branch_id = data.branch_id
            this.dialog = true
        },
        dialog_close() {
            this.form = {
                part_id: "",
                branch_id: "",
                case_id: "",
                ponumber: "",
                qty: 1,
                sonumber: "",
            }
            this.dialog = false
        },
        async save_ctr_part() {
            await axios
                .post(url + "ctr-part/reserve", this.form, this.tk)
                .then((response) => {
                    this.$swal({
                        title: "ส่งอีเมล์ order part เลยหรือไม่ ?",
                        // text: 'xx',
                        icon: "warning",
                        buttons: true,
                        primaryMode: true,
                    }).then((confirm) => {
                        if (confirm) {
                            axios
                                .post(
                                    url + "ctr-part/sendmail",
                                    this.form,
                                    this.tk
                                )
                                .then((response) => {
                                    this.mutatesnackbar()
                                    this.dialog_close()
                                    this.get_data()
                                    if (this.snackbar === true) {
                                        setTimeout(() => {
                                            this.mutatesnackbar()
                                        }, 3000)
                                    }
                                })
                                .catch((error) => {
                                    console.log(error)
                                })
                        } else {
                            this.mutatesnackbar()
                            this.dialog_close()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        }
                    })
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            tk: null,
            data_main: [],
            form_search: "",
            form: {
                part_id: "",
                branch_id: "",
                case_id: "",
                ponumber: "",
                qty: 1,
                sonumber: "",
            },
            text: "Success, Your work has been saved",
            dialog: false,
            chk_search: false,
            case_idR: [(v) => !!v || "Case ID is required"],
            ponumberR: [(v) => !!v || "PO Number is required"],
            sonumberR: [(v) => !!v || "SO Number is required"],
            qtyR: [
                (v) => !!v || "QTY is required",
                (v) => /^\d+$/.test(v) || "QTY be a number",
            ],
            valid: false,
            show: {},
        }
    },
}
</script>
<style scoped>
.bg-tr-1 {
    background-color: rgb(217, 233, 247) !important;
}
</style>
